module.exports = __webpack_public_path__ + "images/remove-gray.svg";